import { UnableToStartCheckoutAbTestReason } from "@redotech/redo-model/checkouts/checkout-ab-test-utils";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const canStartCheckoutAbTest = {
  name: "canStartCheckoutAbTest" as const,
  input: z.null(),
  output: z.union([
    z.object({ canStart: z.literal(true) }),
    z.object({
      canStart: z.literal(false),
      reason: createEnum(UnableToStartCheckoutAbTestReason),
    }),
  ]),
};
export type CanStartCheckoutAbTestOutput = z.infer<
  typeof canStartCheckoutAbTest.output
>;
